function OperatorEnum(operator) {
  switch (operator) {
    case '>':
      return 0
    case '<':
      return 1
    case '>=':
      return 2
    case '<=':
      return 3
    case '=':
      return 4
    case '!=':
      return 5
    case 'BETWEEN':
      return 6
    case 'LIKE':
      return 7
    case 'STARTS WITH':
      return 8
    case 'ENDS WITH':
      return 9
    case 'NOT NULL':
      return 10
    default:
      throw new Error('Operator unrecognized')
  }
}

function IsValidProp(item) {
  return !Array.isArray(item) || (Array.isArray(item) && item.length > 0)
}

function GoTo(e, id) {
  if (e) {
    Toggle(e)
  }

  document.getElementById(id).scrollIntoView()

  const element = document.getElementById(id)
  const headerOffset = 200
  const elementPosition = element.getBoundingClientRect().top
  const offsetPosition = elementPosition + window.pageYOffset - headerOffset

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  })
}

function Toggle(event) {
  // const navs = document
  //   .getElementById('navigation-section')
  //   .getElementsByClassName('nav-item active')

  // Array.prototype.forEach.call(navs, element => {
  //   element.classList.remove('active')
  // })

  // if (event.target.tagName.toLowerCase() === 'span') {
  //   event.target.parentElement.classList.add('active')
  // } else {
  //   event.target.classList.add('active')
  // }
}

export { OperatorEnum, IsValidProp, GoTo }
